import axios from '../../utils/axios';

const Email = {
    subscribe: async (botId: string) =>
        axios.post(`/integrations/email/subscribe/${botId}`)
};

export default Email;
